import React from 'react';

interface TabsProps {
  data: {
    id?: string;
    items?: Array<{ label: string; content: string }>;
    [key: string]: unknown;
  };
  styles?: string;
}

export const Tabs: React.FC<TabsProps> = ({ data: _data, styles: _styles }) => (
  <div className="">
    <div className="flex gap-2 mb-4 border-b">
      <button className="px-4 py-2 bg-gray-100 rounded-t">Tab 1</button>
      <button className="px-4 py-2 text-[var(--text-muted)]">Tab 2</button>
    </div>
  </div>
);
